export class LocalStorageRelatedData {
    static readonly USER_NAME = "userName";
    static readonly LOGGED_IN_USER_ACCESS_DOMAINS = "loggedInUserAccessDomains";
    static readonly DEVICE_ID = "deviceId";
    static readonly TOKEN = "token";
    static readonly FIRST_NAME = "firstName";
    static readonly LOGGED_IN_USER_ID = "loggedInUserId";
    static readonly LAST_NAME = "lastName";
    static readonly NOTIFICATION_DATA = "notificationData";
    static readonly LOGGED_IN_USER_ACCOUNTS = "loggedInUserAccounts";
    static readonly USER_PREFERENCES = "userPreferences";
    static readonly TEAM_INVITE_ID = "teamInviteId";
    static readonly IS_SIGN_UP_COMPLETE = "ISUC";
    static readonly CREATED_DATE_TIME = "tdc";
    static readonly DASHBOARD_VIEW_MODE = "dashboardViewMode";
    static readonly CHAT_INITIAL_DATA_FETCHED = "CIDF";
    static readonly LOGGED_IN = "logged-in";
    static readonly LOGGED_OUT = "logged-out";
    static readonly USER_COUNTRY_ID = "UCID";
    static readonly WORKFLOW_TYPE_PRIORITY_AND_STATUS = "WTPS";


    static SessionStorage = class {
        static readonly RC = "rc";
        static readonly CHUNK_RELOAD_DONE = "CRD";
        static readonly SELECTED_REPO_ID: string = "RID";
        static readonly CURRENT_GITHUB_STATE = "CGS";
        static readonly USER_SELECTED_ORG_FOR_GITHUB_OAUTH = "USOG";
        static readonly  VIEW_TASK_TEAM_SELECTED_ENTITY: "vtse";
    };
}
